import { createAction, createReducer } from '@reduxjs/toolkit'

import rootInitialState from './rootInitialState'

const resetAction = createAction('root/reset')

const resetUpdatedCustomer = createAction('root/resetUpdatedCustomer')

const appReducer = createReducer(
  {},
  {
    [resetAction.type]: (state: Record<string, unknown>) => ({
      ...rootInitialState,
      ...{
        brand: state.brand,
        auth: state.auth,
        featureFlags: state.featureFlags,
      },
    }),
    [resetUpdatedCustomer.type]: (state: Record<string, unknown>) => ({
      ...rootInitialState,
      ...{
        brand: state.brand,
        auth: state.auth,
        featureFlags: state.featureFlags,
        permissions: state.permissions,
      },
    }),
  },
)

export { resetAction, resetUpdatedCustomer, appReducer }
